/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FastEndpointsProblemDetails,
  FxIdApplicationHandlersNativeStatusNativeStatusDto,
  FxIdApplicationSharedPromoCodesRedeemPromoCodeResult,
  FxIdWebFeaturesNativeInAppValidateInAppRequest,
} from '../models/index';
import {
    FastEndpointsProblemDetailsFromJSON,
    FastEndpointsProblemDetailsToJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFromJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoToJSON,
    FxIdApplicationSharedPromoCodesRedeemPromoCodeResultFromJSON,
    FxIdApplicationSharedPromoCodesRedeemPromoCodeResultToJSON,
    FxIdWebFeaturesNativeInAppValidateInAppRequestFromJSON,
    FxIdWebFeaturesNativeInAppValidateInAppRequestToJSON,
} from '../models/index';

export interface FxIdWebFeaturesNativeDocumentsAcceptDocumentEndpointRequest {
    documentId: number;
    documentVersionId: number;
    token: string;
}

export interface FxIdWebFeaturesNativeInAppValidateInAppEndpointRequest {
    game: string;
    fxIdWebFeaturesNativeInAppValidateInAppRequest: FxIdWebFeaturesNativeInAppValidateInAppRequest;
}

export interface FxIdWebFeaturesNativePromoCodeRedeemPromoCodeEndpointRequest {
    promoCode: string;
    game: string;
    token: string;
}

export interface FxIdWebFeaturesNativeStatusEndpointRequest {
    game: string;
    token: string;
    appStoreCountry?: string | null;
    googlePlayCountry?: string | null;
    clientCountryAlpha3?: string | null;
}

/**
 * 
 */
export class NativeApi extends runtime.BaseAPI {

    /**
     */
    async fxIdWebFeaturesNativeDocumentsAcceptDocumentEndpointRaw(requestParameters: FxIdWebFeaturesNativeDocumentsAcceptDocumentEndpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling fxIdWebFeaturesNativeDocumentsAcceptDocumentEndpoint().'
            );
        }

        if (requestParameters['documentVersionId'] == null) {
            throw new runtime.RequiredError(
                'documentVersionId',
                'Required parameter "documentVersionId" was null or undefined when calling fxIdWebFeaturesNativeDocumentsAcceptDocumentEndpoint().'
            );
        }

        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling fxIdWebFeaturesNativeDocumentsAcceptDocumentEndpoint().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['documentId'] != null) {
            queryParameters['DocumentId'] = requestParameters['documentId'];
        }

        if (requestParameters['documentVersionId'] != null) {
            queryParameters['DocumentVersionId'] = requestParameters['documentVersionId'];
        }

        if (requestParameters['token'] != null) {
            queryParameters['Token'] = requestParameters['token'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/native/games/documents/accept`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async fxIdWebFeaturesNativeDocumentsAcceptDocumentEndpoint(documentId: number, documentVersionId: number, token: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.fxIdWebFeaturesNativeDocumentsAcceptDocumentEndpointRaw({ documentId: documentId, documentVersionId: documentVersionId, token: token }, initOverrides);
    }

    /**
     */
    async fxIdWebFeaturesNativeInAppValidateInAppEndpointRaw(requestParameters: FxIdWebFeaturesNativeInAppValidateInAppEndpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['game'] == null) {
            throw new runtime.RequiredError(
                'game',
                'Required parameter "game" was null or undefined when calling fxIdWebFeaturesNativeInAppValidateInAppEndpoint().'
            );
        }

        if (requestParameters['fxIdWebFeaturesNativeInAppValidateInAppRequest'] == null) {
            throw new runtime.RequiredError(
                'fxIdWebFeaturesNativeInAppValidateInAppRequest',
                'Required parameter "fxIdWebFeaturesNativeInAppValidateInAppRequest" was null or undefined when calling fxIdWebFeaturesNativeInAppValidateInAppEndpoint().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/native/inapp/validate/{Game}`.replace(`{${"Game"}}`, encodeURIComponent(String(requestParameters['game']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesNativeInAppValidateInAppRequestToJSON(requestParameters['fxIdWebFeaturesNativeInAppValidateInAppRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async fxIdWebFeaturesNativeInAppValidateInAppEndpoint(game: string, fxIdWebFeaturesNativeInAppValidateInAppRequest: FxIdWebFeaturesNativeInAppValidateInAppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.fxIdWebFeaturesNativeInAppValidateInAppEndpointRaw({ game: game, fxIdWebFeaturesNativeInAppValidateInAppRequest: fxIdWebFeaturesNativeInAppValidateInAppRequest }, initOverrides);
    }

    /**
     */
    async fxIdWebFeaturesNativePromoCodeRedeemPromoCodeEndpointRaw(requestParameters: FxIdWebFeaturesNativePromoCodeRedeemPromoCodeEndpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FxIdApplicationSharedPromoCodesRedeemPromoCodeResult>> {
        if (requestParameters['promoCode'] == null) {
            throw new runtime.RequiredError(
                'promoCode',
                'Required parameter "promoCode" was null or undefined when calling fxIdWebFeaturesNativePromoCodeRedeemPromoCodeEndpoint().'
            );
        }

        if (requestParameters['game'] == null) {
            throw new runtime.RequiredError(
                'game',
                'Required parameter "game" was null or undefined when calling fxIdWebFeaturesNativePromoCodeRedeemPromoCodeEndpoint().'
            );
        }

        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling fxIdWebFeaturesNativePromoCodeRedeemPromoCodeEndpoint().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['promoCode'] != null) {
            queryParameters['PromoCode'] = requestParameters['promoCode'];
        }

        if (requestParameters['game'] != null) {
            queryParameters['Game'] = requestParameters['game'];
        }

        if (requestParameters['token'] != null) {
            queryParameters['Token'] = requestParameters['token'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/native/promo-code/redeem`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdApplicationSharedPromoCodesRedeemPromoCodeResultFromJSON(jsonValue));
    }

    /**
     */
    async fxIdWebFeaturesNativePromoCodeRedeemPromoCodeEndpoint(promoCode: string, game: string, token: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FxIdApplicationSharedPromoCodesRedeemPromoCodeResult> {
        const response = await this.fxIdWebFeaturesNativePromoCodeRedeemPromoCodeEndpointRaw({ promoCode: promoCode, game: game, token: token }, initOverrides);
        return await response.value();
    }

    /**
     */
    async fxIdWebFeaturesNativeStatusEndpointRaw(requestParameters: FxIdWebFeaturesNativeStatusEndpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FxIdApplicationHandlersNativeStatusNativeStatusDto>> {
        if (requestParameters['game'] == null) {
            throw new runtime.RequiredError(
                'game',
                'Required parameter "game" was null or undefined when calling fxIdWebFeaturesNativeStatusEndpoint().'
            );
        }

        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling fxIdWebFeaturesNativeStatusEndpoint().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['game'] != null) {
            queryParameters['Game'] = requestParameters['game'];
        }

        if (requestParameters['token'] != null) {
            queryParameters['Token'] = requestParameters['token'];
        }

        if (requestParameters['appStoreCountry'] != null) {
            queryParameters['AppStoreCountry'] = requestParameters['appStoreCountry'];
        }

        if (requestParameters['googlePlayCountry'] != null) {
            queryParameters['GooglePlayCountry'] = requestParameters['googlePlayCountry'];
        }

        if (requestParameters['clientCountryAlpha3'] != null) {
            queryParameters['ClientCountryAlpha3'] = requestParameters['clientCountryAlpha3'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/native/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdApplicationHandlersNativeStatusNativeStatusDtoFromJSON(jsonValue));
    }

    /**
     */
    async fxIdWebFeaturesNativeStatusEndpoint(game: string, token: string, appStoreCountry?: string | null, googlePlayCountry?: string | null, clientCountryAlpha3?: string | null, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FxIdApplicationHandlersNativeStatusNativeStatusDto> {
        const response = await this.fxIdWebFeaturesNativeStatusEndpointRaw({ game: game, token: token, appStoreCountry: appStoreCountry, googlePlayCountry: googlePlayCountry, clientCountryAlpha3: clientCountryAlpha3 }, initOverrides);
        return await response.value();
    }

}
